"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-53a05f1a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "border-bottom"
};
const _hoisted_2 = { class: "flex-justify-between" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "セクション:", -1 /* HOISTED */));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-plus" }, null, -1 /* HOISTED */));
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = {
    key: 0,
    class: "d-flex flex-wrap mb-1"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "text-ellipsis" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("small", { class: "text-gray" }, "セクションがありません", -1 /* HOISTED */));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = {
    key: 1,
    class: "mt-15"
};
const _hoisted_14 = { class: "flex-justify-between" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "業務セクション:", -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-plus" }, null, -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { key: 0 };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "text-ellipsis" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 1 };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("small", { class: "text-gray" }, "業務セクションがありません", -1 /* HOISTED */));
const _hoisted_24 = [
    _hoisted_23
];
const vue_3 = require("vue");
const SectionModal_vue_1 = __importDefault(require("./SectionModal.vue"));
const roles_1 = require("../../js/roles");
const RoleSectionListModal_vue_1 = __importDefault(require("./RoleSectionListModal.vue"));
const models_1 = require("../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionList',
    setup(__props) {
        const role = (0, vue_3.inject)('roleView');
        const selectedSection = (0, vue_3.ref)(null);
        const isSectionModalOpen = (0, vue_3.ref)(false);
        const isSectionModalLoading = (0, vue_3.ref)(false);
        const loadingSectionIds = (0, vue_3.ref)({});
        const isRoleSectionModalOpen = (0, vue_3.ref)(false);
        const isRoleSectionModalLoading = (0, vue_3.ref)(false);
        const isGroupRole = (0, vue_3.computed)(() => {
            return role?.value.isGroupWide || false;
        });
        const roleSections = (0, vue_3.computed)(() => {
            return role?.value.roleSections || [];
        });
        const sections = (0, vue_3.computed)(() => {
            return role?.value.sections || [];
        });
        function sectionLabel(section) {
            const out = section.isRest ? '休憩' : `${section.purpose}`;
            return `${out} ${section.from} ~ ${section.to}`;
        }
        function roleStyle(section) {
            return {
                backgroundColor: '#' + section.color,
                color: !section.color || section.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT ? '' : '#fff'
            };
        }
        function isChipLoading(section) {
            return loadingSectionIds.value[section.id] ? 'loading' : '';
        }
        function openSectionModal(section) {
            if (isGroupRole.value) {
                return;
            }
            selectedSection.value = section;
            isSectionModalOpen.value = true;
        }
        async function handleSectionSubmit(section) {
            if (section.from === "" || section.to === "" || isSectionModalLoading.value) {
                return;
            }
            isSectionModalLoading.value = true;
            const payload = {
                roleId: role?.value.id || 0,
                from: section.from,
                to: section.to,
                purpose: section.purpose,
                color: section.color,
                isRest: section.isRest,
                memo: section.memo,
            };
            if (section.id) {
                payload.sectionId = section.id;
            }
            if (section.roleId) {
                payload.roleSectionId = section.roleId;
            }
            try {
                await (0, roles_1.handleSectionUpdate)(payload);
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                isSectionModalOpen.value = false;
                isSectionModalLoading.value = false;
            }
        }
        async function handleRoleSectionSubmit(roleSectionId) {
            if (isRoleSectionModalLoading.value) {
                return;
            }
            isRoleSectionModalLoading.value = true;
            try {
                await (0, roles_1.submitAddRoleSection)(role?.value.id, roleSectionId);
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                isRoleSectionModalLoading.value = false;
                isRoleSectionModalOpen.value = false;
            }
        }
        function openRoleSectionModal() {
            isRoleSectionModalOpen.value = true;
        }
        async function handleSectionDeleteFromModal(sectionId) {
            try {
                await (0, roles_1.handleSectionDelete)(sectionId, role?.value.id);
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                isSectionModalOpen.value = false;
            }
        }
        async function handleSectionDeleteFromChip(event, sectionId) {
            event.stopPropagation();
            if (loadingSectionIds.value[sectionId]) {
                return;
            }
            try {
                loadingSectionIds.value[sectionId] = true;
                await (0, roles_1.handleSectionDelete)(sectionId, role?.value.id);
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                delete loadingSectionIds.value[sectionId];
            }
        }
        function handleCloseModal() {
            isSectionModalOpen.value = false;
            isRoleSectionModalOpen.value = false;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#app" }, [
                    (isSectionModalOpen.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SectionModal_vue_1.default, {
                            key: 0,
                            section: selectedSection.value,
                            "is-loading": isSectionModalLoading.value,
                            onCloseModal: handleCloseModal,
                            onSectionSubmit: handleSectionSubmit,
                            onSectionDelete: handleSectionDeleteFromModal
                        }, null, 8 /* PROPS */, ["section", "is-loading"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isRoleSectionModalOpen.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleSectionListModal_vue_1.default, {
                            key: 1,
                            "is-loading": isRoleSectionModalLoading.value,
                            onCloseModal: handleCloseModal,
                            onRoleSectionSubmit: handleRoleSectionSubmit
                        }, null, 8 /* PROPS */, ["is-loading"]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])),
                (!isGroupRole.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createCommentVNode)(" Sections "),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            _hoisted_3,
                            (0, vue_2.createElementVNode)("button", {
                                onClick: _cache[0] || (_cache[0] = ($event) => (openSectionModal(null))),
                                class: "btn btn-slot-add-primary"
                            }, _hoisted_5)
                        ]),
                        (sections.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(sections.value, (section) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        class: "role-section-chip-wrapper",
                                        key: section.id
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            onClick: ($event) => (openSectionModal(section)),
                                            class: "chip c-hand role-section-slot-chip d-flex",
                                            style: (0, vue_2.normalizeStyle)(roleStyle(section))
                                        }, [
                                            (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)(sectionLabel(section)), 1 /* TEXT */),
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(isChipLoading(section))
                                            }, [
                                                (0, vue_2.createElementVNode)("i", {
                                                    onClick: ($event) => (handleSectionDeleteFromChip($event, section.id)),
                                                    class: "icon icon-cross ml-2 c-hand"
                                                }, null, 8 /* PROPS */, _hoisted_9)
                                            ], 2 /* CLASS */)
                                        ], 12 /* STYLE, PROPS */, _hoisted_7)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, _hoisted_12))
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (!isGroupRole.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            _hoisted_15,
                            (0, vue_2.createElementVNode)("button", {
                                onClick: _cache[1] || (_cache[1] = ($event) => (openRoleSectionModal())),
                                class: "btn btn-slot-add-primary"
                            }, _hoisted_17)
                        ]),
                        (roleSections.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(roleSections.value, (roleSection) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        class: "role-section-chip-wrapper",
                                        key: roleSection.id
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            onClick: ($event) => (openSectionModal(roleSection)),
                                            class: "chip c-hand role-section-slot-chip d-flex",
                                            style: (0, vue_2.normalizeStyle)(roleStyle(roleSection))
                                        }, [
                                            (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(roleSection.name), 1 /* TEXT */),
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(["d-flex", isChipLoading(roleSection)])
                                            }, [
                                                (0, vue_2.createElementVNode)("i", {
                                                    onClick: ($event) => (handleSectionDeleteFromChip($event, roleSection.id)),
                                                    class: "icon icon-cross ml-2 c-hand"
                                                }, null, 8 /* PROPS */, _hoisted_21)
                                            ], 2 /* CLASS */)
                                        ], 12 /* STYLE, PROPS */, _hoisted_19)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, _hoisted_24))
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
